::ng-deep app-foot-note-container{display:flex;flex:1 0 0}
/*# sourceMappingURL=side-note-container.component-YSXZRXMX.css.map */
